import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthserviceService } from '../auth/authservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { BasemodelService } from '../basemodel.service';
import { DataServiceService } from '../data-service.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginform!: FormGroup
  showpassword: boolean = false;
  isFormInvalid = false;
  loginError: boolean = false;
  params: any;
  isLoading: any = true;
  constructor(private fb: FormBuilder, private authservice: AuthserviceService, private router: Router, private spinner: NgxSpinnerService, private route: ActivatedRoute, private baseModel: BasemodelService, private data: DataServiceService) { }
  formRouteMap: { [key: string]: string } = {
    BUILDING_IMAGE_DATA: 'building-image-data',
    HYGIENE_STAFF_ATTENDANCE: 'hygieneStaffAttendance',
    HYGIENE_ACTIVITY: 'hygine-cleaning',
    HYGIENE_DAY_WISE: 'hygiene-day-wise-report',
    TICKETING_REPORT: 'ticketingStaffAttendance',
    HYGIENE_LIVE_UPDATE: 'housekeeping-dashboard',
    HOUSEKEEPING_COMMAND_CENTRE: 'house-keeping-command-centre',
    HOUSEKEEPING_DASHBOARD: 'housekeeping-dashboard',
  };
  async ngOnInit(): Promise<void> {
    localStorage.clear();

    this.route.queryParams.subscribe(async params => {  // Mark the callback function as async
      this.isLoading = true;
      // console.log(params);
      this.params = params;

      localStorage.setItem('url', environment.employeeURL + "/jwtV2/api/employee/jwtV2/api/employee");
      this.spinner.show()
      try {
        await this.baseModel.getURLS();
        this.spinner.hide();// Using await inside an async function
      } catch (err) {
        console.error('Error in ngOnInit:', err);
      }

      if (params['token'] && params['module'] && params['logoutPage']) {
        localStorage.setItem('token', params['token']);

        localStorage.setItem('logoutPage', params['logoutPage']);
        localStorage.setItem('userName', params['userName']);
        localStorage.setItem('campusName', params['campusName']);
        localStorage.setItem('deviceSessionId', params['deviceSessionId']);
        localStorage.setItem('tokenRefreshKey', params['tokenRefreshKey']);
        localStorage.setItem('loginTime', params['loginTime']);
        localStorage.setItem('time', params['tokenValidTime']);
        localStorage.setItem('userId', params['userId']);
        localStorage.setItem('uniqueRefId', params['employeeUniqueRefId']);
        localStorage.setItem('employeeId', params['employeeId']);

        if (params['module'] === 'merakiDashboard') {
          this.router.navigate(['/merakiDashboard']);
        }
        if (params['module'] === 'attendance') {
          window.location.href = '/Attendance';
        }
        if (params['module'] === 'cctvdashboard') {
          this.router.navigate(['/totaldvr']);
          // window.location.href = '/dashboard';
        }
        if (params['module'] === 'counselling') {
          window.location.href = '/counselling';
          // this.router.navigate(['/counselling']);
        }
        if (params['module'] === 'ReceiptCancellationApprovalByDO') {
          window.location.href = '/ReceiptCancellationApproval';
        }
        if (params['module'] === 'CounsellingReport') {
          window.location.href = '/studentcounsellingdashboard';
        }
        if (params['module'] === 'IpeMarksEntryForm') {
          window.location.href = '/IpeMarks';
          // this.router.navigate(['/IpeMarks']);
        }

        if (params['module'] === 'AcademicCounsel') {
          this.router.navigate(['/AcademicCounsel']);
          // window.location.href = '/AcademicCounsel';
        }
        if (params['module'] === 'courseMaster') {
          window.location.href = '/courseMaster';
        }
        if (params['module'] === 'entityChange') {
          window.location.href = '/migration'
        }
        if (params['module'] === 'Notification') {
          window.location.href = '/Notification'
        }
        if (params['module'] === 'progressReport') {
          window.location.href = 'parent/progressReport';
        }
        if (params['module'] === 'studentGrievance') {
          window.location.href = '/grievanceDashboard';
        }
        if (params['module'] === 'CounsellingExcelReport') {
          window.location.href = '/studentCounsellingExcelReport';
        }
        if (params['module'] === 'gmDashboard') {
          window.location.href = '/gmDashboard';
        }
        if (params['module'] === 'HygieneReport') {
          window.location.href = '/hygine';
        }
        if (params['module'] === 'FacultyTrackingDashboard') {
          window.location.href = '/facultyTracking/dashboard';
        }

        if (params['module'] === 'facultyTrackingReport') {
          window.location.href = '/facultyTrackingDashboard';
        }

        if (params['module'] === 'SectionWiseFacultyTrackingReport') {
          window.location.href = '/facultyTracking/sectionWiseReport';
        }

        if (params['module'] === 'EmployeeGrievance') {
          window.location.href = '/employeeGrievance/dashboard';
        }
        if (params['module'] === 'UserDashboard') {
          window.location.href = '/userdashboard';
        }
        if (params['module'] === 'HrmsReport') {
          window.location.href = '/HrmsReport'
        }

        if (params['module'] === 'JeemainsSession1') {
          window.location.href = '/jee'
        }
        if (params['module'] === 'JeemainsSession2') {
          window.location.href = '/jee2'
        }

        if (params['module'] === 'JeemainsRookieSession1') {
          window.location.href = '/rookie'
        }

        if (params['module'] === 'JeemainsRookieSession2') {
          window.location.href = '/rookie'
        }
        if (params['module'] === 'CounsellingDetailsExcelReport') {
          window.location.href = '/studentCounsellingdetailesReport'
        }
        if (params['module'] === 'buildingData') {
          window.location.href = '/BuildingData'
        }
        if (params['module'] === 'BuildingMaintenance') {
          this.handleNavigation();
        }
        if (params['module'] === 'StdWellBeingAndAdaptability') {
          window.location.href = '/studentfeedback'
        }
        if (params['module'] === 'MessDaysheetSubmit') {
          window.location.href = '/messDetailsInventory'
        }
        if (params['module'] === 'MessDaysheetClose') {
          window.location.href = '/messDoDetails'
        }
        if (params['module'] === 'MessDaysheetCloseExcel') {
          window.location.href = '/messClosedDetails'
        }
        if (params['module'] === 'MealRequest') {
          window.location.href = '/mealRequest'
        }
        if (params['module'] === 'SelfAssessment') {
          window.location.href = '/selfAssessment'
        }
        if (params['module'] === 'ScenarioAssessment') {
          window.location.href = '/ScenarioAssessment'
        }
        if (params['module'] === 'MealOrderSummary') {
          window.location.href = '/mealOrderSummary';
        }
        if (params['module'] === 'StudentWellBeing') {
          window.location.href = '/studentwellbeing';
        }
        if (params['module'] === 'WellBeingReferralForm') {
          window.location.href = '/WellbieingReferal';
        }
        if (params['module'] === 'StudentWellBeingReport') {
          window.location.href = '/studentwellbeingReport';
        }
        if (params['module'] === 'wellBeingReferralReport') {
          window.location.href = '/WellbeingReferalReport';
        }
        if (params['module'] === 'MrfDashboard') {
          window.location.href = '/hrDetails/mrfDashboard';
        }
        if (params['module'] === 'employeeWithdrawal') {
          window.location.href = '/hrDetails/employeeWithdrawal';
        }
        if (params['module'] === 'manPowerRequisitionForm') {
          window.location.href = '/hrDetails/manPowerRequisitionForm';
        }
        if (params['module'] === 'LogTracking') {
          window.location.href = '/log_tracking';
        }
        if (params['module'] === 'MissingMenuCardItems') {
          window.location.href = '/addNewMenuItem';
        }
        if (params['module'] === 'AdminReports') {
          window.location.href = '/adminDashboardReports';
        }
        if (params['module'] === 'StudentAttendancesNew') {
          window.location.href = '/StudentAttendances';
        }
        if (params['module'] === 'allIndiaScoreRegistration2026') {
          window.location.href = '/score/scoreRegistration';
        }
        if (params['module'] === 'AllIndiaScoreReports') {
          window.location.href = '/score/scoreReports';
        }
        if (params['module'] === 'messOperations') {
          window.location.href = '/MessDetails';
        }
         if (params['module'] === 'EmployeeHub') {
          // Lazy route: FEATURE_LAZY_ROUTES path `appScaits` + AppScaitsRouting `mainDashboard`
          window.location.href = '/appScaits/mainDashboard';
        }
    


        if (params['module'] === 'buildingUpdate') {
          window.location.href = '/employeeProfile';
        }


      } else if (params['token'] && params['module'] && params['backendBaseURL']) {
        localStorage.setItem('token', params['token']);
        localStorage.setItem('backendBaseURL', params['backendBaseURL']);
        localStorage.setItem('logoutPage', params['logoutPage']);
        localStorage.setItem('userName', params['userName']);
        localStorage.setItem('campusName', params['campusName']);
        localStorage.setItem('deviceSessionId', params['deviceSessionId']);
        localStorage.setItem('tokenRefreshKey', params['tokenRefreshKey']);
        localStorage.setItem('loginTime', params['loginTime']);
        localStorage.setItem('time', params['tokenValidTime']);
        localStorage.setItem('userId', params['userId']);
        localStorage.setItem('uniqueRefId', params['uniqueRefId']);
        localStorage.setItem('employeeId', params['employeeId']);

        if (params['module'] === 'cctvdashboard') {
          window.location.href = '/totaldvr';
          // window.location.href = '/dashboard';
        }
        if (params['module'] === 'counselling') {
          window.location.href = '/counselling';
        }
        if (params['module'] === 'AcademicCounsel') {
          window.location.href = '/AcademicCounsel';
        }
        if (params['module'] === 'courseMaster') {
          window.location.href = '/courseMaster';
        }
        if (params['module'] === 'progressReport') {
          window.location.href = 'parent/progressReport';
        }
        if (params['module'] === 'studentGrievance') {
          window.location.href = '/grievanceDashboard';
        }
        if (params['module'] === 'gmDashboard') {
          window.location.href = '/gmDashboard';
        }
        if (params['module'] === 'FacultyTrackingDashboard') {
          window.location.href = '/facultyTracking/dashboard';
        }

        if (params['module'] === 'SectionWiseFacultyTrackingReport') {
          window.location.href = '/facultyTracking/sectionWiseReport';
        }

        if (params['module'] === 'facultyTrackingReport') {
          window.location.href = '/facultyTrackingDashboard';
        }

        if (params['module'] === 'EmployeeGrievance') {
          window.location.href = '/employeeGrievance/dashboard';
        }

        if (params['module'] === 'UserDashboard') {
          window.location.href = '/userdashboard';
        }
        if (params['module'] === 'HrmsReport') {
          window.location.href = '/HrmsReport'
        }
        if (params['module'] === 'BuildingImage') {
          window.location.href = '/BuildingImageList'
        }
        if (params['module'] === 'MessDaysheetSubmit') {
          window.location.href = '/messDetailsInventory'
        }
        if (params['module'] === 'MessDaysheetClose') {
          window.location.href = '/messDoDetails'
        }
        if (params['module'] === 'MessDaysheetCloseExcel') {
          window.location.href = '/messClosedDetails'
        }
        if (params['module'] === 'MealRequest') {
          window.location.href = '/mealRequest'
        }
        if (params['module'] === 'MealOrderSummary') {
          window.location.href = '/mealOrderSummary';
        }
        if (params['module'] === 'StudentWellBeing') {
          window.location.href = '/studentwellbeing';
        }
        if (params['module'] === 'StudentWellBeingReport') {
          window.location.href = '/studentwellbeingReport';
        }
        if (params['module'] === 'MrfDashboard') {
          window.location.href = '/hrDetails/mrfDashboard';
        }
        if (params['module'] === 'employeeWithdrawal') {
          window.location.href = '/hrDetails/employeeWithdrawal';
        }
        if (params['module'] === 'manPowerRequisitionForm') {
          window.location.href = '/hrDetails/manPowerRequisitionForm';
        }

        if (params['module'] === 'LogTracking') {
          window.location.href = '/log_tracking';
        }
        if (params['module'] === 'MissingMenuCardItems') {
          window.location.href = '/addNewMenuItem';
        }
        if (params['module'] === 'StudentAttendancesNew') {
          window.location.href = '/StudentAttendances';
        }
        if (params['module'] === 'allIndiaScoreRegistration2026') {
          window.location.href = '/score/scoreRegistration';
        }
        if (params['module'] === 'AllIndiaScoreReports') {
          window.location.href = '/score/scoreReports';
        }
        if (params['module'] === 'messOperations') {
          window.location.href = '/MessDetails';
        }
         if (params['module'] === 'EmployeeHub') {
          // Lazy route: FEATURE_LAZY_ROUTES path `appScaits` + AppScaitsRouting `mainDashboard`
          window.location.href = '/appScaits/mainDashboard';
        }
        if (params['module'] === 'buildingUpdate') {
          window.location.href = '/employeeProfile';
        }

      }
      this.isLoading = false;
    });

    if (localStorage.getItem('token') && !this.params) {
      this.router.navigate(['/dashboard'], { queryParams: { part: 'dashboard', search: 'campusdetails', year: 2023 } });
    } else {
      this.loginform = this.fb.group({
        userid: ['', Validators.required],
        password: ['', Validators.required],
        accept: [false, Validators.requiredTrue]
      });
    }

    this.isLoading = false;
  }

  token() {
    if (this.loginform.valid) {
      this.isFormInvalid = false;
      const credential = {
        username: this.loginform.value.userid,
        password: this.loginform.value.password
      }
      this.spinner.show();
      this.authservice.onlogin(credential).subscribe((res: any) => {
        console.log(res);
        localStorage.setItem('token', res.token);
        this.router.navigate(['/dashboard'])
        this.spinner.hide();
        this.loginform.reset()

      }, (error: any) => {
        this.loginError = true
        if (error.status === 401) {
          console.error('Unauthorized access. Please check your credentials.');
          this.loginform.reset()
        } else {
          console.error('Login failed:', error);
        }
        this.spinner.hide();
      }
      )

    } else {
      this.isFormInvalid = true;
    }
  }

  toggleshow() {
    this.showpassword = !this.showpassword
  }
  handleNavigation() {

    this.data.getUserForms().subscribe({
      next: (response: any) => {

        const buildingForms = response.userAppForms.find(
          (m: any) => m.formGroup === 'BUILDING_MAINTENANCE'
        )?.appForms || [];

        // ❌ No forms
        if (!buildingForms.length) {
          this.router.navigate(['no-access']);
          return;
        }

        // ✅ Dynamic (API order)
        const selectedForm = buildingForms[0]?.appFormName;

        console.log('Selected Form:', selectedForm);

        const route = this.formRouteMap[selectedForm];

        console.log('Route:', route);

        // ❌ Invalid route
        if (!route) {
          this.router.navigate(['no-access']);
          return;
        }

        // ✅ Navigate
        this.router.navigate([route]);
      },

      error: (err: any) => {
        console.error('API Error:', err);
        this.router.navigate(['no-access']);
      }
    });
  }
}
